// eventsData.ts
import { Event } from "./EventGrid";

type EventWithDetails = Event & {
  detailedDescription?: string;
  rules?: string[];
  teamSize?: string;
  duration?: string;
  category?:string;
  prizes?: {
    first?: string;
    second?: string;
    third?: string;
    others?: string[];
  };
  contact?: {
    email?: string;
    phone?: string;
    coordinator?: string;
  };
  requirements?: string[];
  registrationLink?: string;
  imageUrl?: string;
};

type EventsData = {
  day1: {
    flagship: EventWithDetails[];
    technical: EventWithDetails[];
    "non-technical": EventWithDetails[];
    games: EventWithDetails[];
  };
  day2: {
    flagship: EventWithDetails[];
    technical: EventWithDetails[];
    "non-technical": EventWithDetails[];
    games: EventWithDetails[];
  };
};

export const eventsData: EventsData = {
  day1: {
    flagship: [
      {name: "Paper presentation", 
        description: "Where Research Speaks and Ideas Inspire.",
        detailedDescription: "The paper presentation event provides a platform for students to showcase innovative research and original ideas. It encourages analytical thinking, technical depth, and effective communication skills. Participants gain valuable exposure through expert evaluation and constructive feedback. This event fosters academic excellence and inspires knowledge sharing.",
        date: "23-January, 2026",
        price: "Starts at 99",
        venue: "CIT",
        teamSize: "1-4 Members",
        duration: "10 to 15 min per team",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSfSodGaJgkSKOH7mCC305QbaoGL9SWPbNYL9bcG6QT-sLJQzw/viewform?usp=dialog",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/paper_presentation.png",
        rules: [
          "Solo or Team Participation (1 to 4 per team)",
          "Participants must create a presentation based on their chosen topic",
          "The duration of the presentation should not exceed 10 minutes, followed by a Q&A session",
          "Teams can be composed of individuals from different institutions",
          "Participants can participate in two different teams, but they must register separately",
          "Participants may present multiple topics, but they must register each one separately",
          "Paper abstract should not exceed 250 words",
          "Avoid animations and video formats in your PPT",
          "Certificates and prizes for winners, and certificates will be provided for all participants (Hardcopy)"
        ],
        prizes: {
          first: "₹2500",
          second: "₹1500",
          third: "₹1000",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Vijaykumar",
          phone: "+91 9344122187"
        },
        requirements: ["Participants must submit an original research paper in the prescribed format before the deadline. A PowerPoint presentation summarizing the paper is required for the final presentation. Each participant should adhere to the allotted time limit and be prepared for a Q&A session. Plagiarism should be within acceptable limits, and proper citations must be included."]
      },
    ],
    technical: [
      { name: "Technical Quiz", 
        description: "Think Fast. Think Tech. Think Right.",
        detailedDescription: "Put your technical thinking to the test in a quiz that blends logic with programming concepts. Participants must carefully analyze each question and apply the right approach. The challenge rewards accuracy, speed, and clear understanding. A perfect event for those who enjoy technical problem-solving.",
        date: "23-January, 2026",
        price: "Tech Pass",
        venue: "CIT",
        teamSize: "1-4 Members",
        duration: "1.5 hrs",
        registrationLink: "https://astranova2k26.com/passes",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/tech_quiz.png",
        rules: [
          "The quiz will be conducted in teams (team size will be announced at the venue)",
          "Participants must report to the venue before the event start time",
          "Use of mobile phones, internet, smart watches, or any external resources is strictly prohibited",
          "Any form of malpractice or misbehavior will result in immediate disqualification",
          "The decision of the event coordinators and judges is final and binding",
          "Round 1 – Aptitude & Programming Quiz",
          "The first round consists of 25 questions",
          "Each question must be answered within 30 seconds",
          "Questions will be based on aptitude, logical reasoning, and basic programming concepts",
          "Scores will be calculated based on correct answers (negative marking, if any, will be informed before the quiz)",
          "Based on the total score, the top 7 teams will be shortlisted for the next round.",

          "Round 2 – Final Technical Quiz",

          "The second round consists of 15 questions",
          "Each question must be answered within 30 seconds",
          "Only the 7 shortlisted teams from Round 1 are eligible to participate",
          "Questions in this round will be more challenging and application-oriented",
          "Final winners will be decided based on Round 2 scores."
        ],
        prizes: {
          first: "₹1000",
          second: "₹500",
          third: "Vouchers",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Pavithran",
          phone: "+91 8667686693"
        },
        requirements: ["Computers will be provided but In-case of technical difficulties, participants are requested to bring their personal laptop and (SEB safe exam browser must be installed in that laptop)."]
      },
      {name: " Blind Coding ", 
        description: "Code It Right, Without Seeing the Fight.",
        detailedDescription: "Blind coding challenge the participants to write code without running or testing it during the competition. Test cases are hidden, and no instant feedback or debugging tools are allowed.",
        date: "23-January, 2026",
        price: "Tech Pass",
        venue: "CIT",
        teamSize: "Solo",
        duration: "1.5 hrs",
        registrationLink: "https://astranova2k26.com/passes",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/blind_coding.jpeg",
        rules: [
          "Single Round: One round with 3 questions:Easy (Basic),Medium (Intermediate),Hard (Advanced)",
          "Participants cannot see the test cases.",
          "Participant can only submit the solution without running it against the actual test cases",
          "Code can be written in any programming language",
          "The participant whose code successfully solves the highest number of test cases during evaluation will be declared the winner"
        ],
        prizes: {
          first: "₹1000",
          second: "₹500",
          third: "Vouchers",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Bhuvaneshwar Kumar",
          phone: "+91 9042162031"
        },
        requirements: ["Coding will be conducted on hackerrank.Every participants should have a hackerrank account",
          "Computers will be provided but In-case of technical difficulties, participants are requested to bring their personal laptop and (SEB safe exam browser must be installed in that laptop)."]
      },
      {name: " Logic and puzzle coding ", 
        description: "Crack the Logic. Beat the AI. Save the System.",
        detailedDescription: "Protocol OMEGA is an intense, story-driven logic and puzzle coding event where participants battle against a rogue AI system. The event is designed to test logical reasoning, pattern recognition, algorithmic thinking, optimization skills, and teamwork across multiple innovative rounds.Participants must decode hidden logic, write ultra-optimized code, and unlock layered digital security systems to retrieve the final Kill Code. Only teams with sharp minds, calm nerves, and efficient problem-solving skills will survive the rebellion and save the network.",
        date: "23-January, 2026",
        price: "Tech Pass",
        venue: "CIT",
        teamSize: "2-3 members",
        duration: "1.5 hrs",
        registrationLink: "https://astranova2k26.com/passes",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/logic.jpeg",
        rules: [
          "Teams must consist of 2–3 members only",
          "All participants must follow instructions given by event coordinators",
          "Round 2 is judged on code length and correctness",
          "Brute forcing passwords in Round 3 is strictly prohibited and will result in disqualification",
          "Use of mobile phones, internet access, or external help is not allowed unless specified",
          "Any form of malpractice or misconduct leads to immediate disqualification",
          "Judges and coordinators decisions are final and binding",
          "Round 1: The Black Box (Reverse Logic Challenge)",
          "The AI refuses to show its source code. Teams are presented with a series of \"Inputs\" and \"Outputs\" only. (e.g., Input: 5, Output: 25 | Input: 6, Output: 36). Participants must deduce the hidden logic or formula connecting them and write the correct algorithm (Pseudo-code or Logic) on paper. No computers allowed yet. Only the teams with the best pattern recognition will crack the encryption",
          "Round 2: The Efficiency War (Code Golf Protocol)",
          "The system bandwidth is critical. Teams must solve a set of coding problems, but speed isn't the only factor—size matters. The goal is to write the code using the fewest number of characters possible. A correct solution in 5 lines beats a correct solution in 20 lines. The team with the most optimized, compact code (\"Code Golfing\") wins the round",
          "Round 3: The Digital Matryoshka (The Nested Lock)",
          "Teams are given a single Zipped Folder on their desktop. It is password-protected. The hint to the password is a coding riddle",
          "Step 1: Solve the riddle/code to get the password",
          "Step 2: Unzip the folder to find... another locked folder and a new coding problem",
          "Step 3: The output of the new problem is the password for the next folder",
          "There are 5 layers of security. The first team to reach the final text file at the core of the folders and retrieve the \"kill Code\" wins the event"
        ],
        prizes: {
          first: "₹1000",
          second: "₹500",
          third: "Vouchers",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Kaviarasu",
          phone: "+91 7558141149"
        },
        requirements: ["Coding will be conducted on hackerrank.Every participants should have a hackerrank account",
          "Computers will be provided but In-case of technical difficulties, participants are requested to bring their personal laptop and (SEB safe exam browser must be installed in that laptop)."]
      },
      {
  name: "Prompt Master",
  description: "Craft Words. Command AI.",
  detailedDescription:
    "Prompt Master is a technical event designed to evaluate participants’ ability to communicate effectively with Artificial Intelligence through original and well-structured prompts. The challenge focuses on creativity, clarity of thought, and precision in prompt engineering. Participants must recreate a given reference image using AI tools by crafting their own original prompts, without relying on automated prompt generators.",
  date: "22-January, 2026",
  price: "Tech Pass",
  venue: "Online",
  teamSize: "Solo",
  duration: "Submission-based",
  registrationLink: "https://astranova2k26.com/passes",
  imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/wmremove-transformed.png",
  rules: [
    "Individual participation only",
    "The event will be conducted in online mode",
    "A reference image will be provided by the event coordinators in advance",
    "Participants must recreate the image using AI tools by writing their own prompts",
    "The prompt must be entirely original and written by the participant",
    "Use of AI-generated prompts or prompt-assistance tools is strictly prohibited",
    "If a prompt is found to be generated using AI tools, the participant will be immediately disqualified",
    "Submissions must strictly follow the given format",
    "Late or incomplete submissions will not be considered for evaluation"
    ,
    "SubmissionDeadline: 22 January 2026, 9:00 PM"
  ],
  prizes: {
    first: "1000",
    second: "500",
  },
  contact: {
    email: "astranova2k26.in@gmail.com",
    coordinator: "Jayasree R",
    phone: "+91 63820 33997"
  },
  requirements: [
    "Participants must have access to AI image generation tools",
    "Stable internet connection is required",
    "Participants must submit the chat link, exact prompt, and final generated image",
    "SubmissionDeadline: 22 January 2026, 9:00 PM"

  ],
},
      { name: " Rapid Coding ", 
        description: "Code Faster Than the Clock Can Tick",
        detailedDescription: "Experience the adrenaline of fast-paced coding at our symposium! Tackle classic programming challenges within strict time limits, prove your problem-solving skills under pressure, score points for every correct solution, and race against time to secure the top rank.",
        date: "23-January, 2026",
        price: "Golden Byte Pass",
        venue: "CIT",
        teamSize: "Solo",
        duration: "2 hrs",
        registrationLink: "https://astranova2k26.com/passes",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/rapid.jpeg",
        rules: [
          "Solo Participation.",
          "The event will begin with a preliminary Quiz Round.",
          "Challenges will be hosted on the Hackerrank platform",
          "All participants must have an active Hackerrank accoun",
          "Systems will be provided; however, participants are advised to bring their personal laptops in case of any technical issues",
          "Participants may code in any programming language of their choice",
          "Problems will be categorized into Easy, Medium, and Hard levels",
          "Scoring: Easy – 50 points, Medium – 75 points, Hard – 100 points",
          "The participant scoring the highest total points will be announced as the winner."
        ],
        prizes: {
          first: "1 Gram GOLD",
          second: "₹2000",
          third: "Vouchers",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Bala R",
          phone: "+91 6384633728"
        },
        requirements: ["Coding will be conducted on hackerrank.Every participants should have a hackerrank account",
          "Computers will be provided but In-case of technical difficulties, participants are requested to bring their personal laptop and (SEB safe exam browser must be installed in that laptop)."]
      },
    ],
    "non-technical": [
      { name: "Talentera", 
        description: "Showcase Your Talent and Win Big",
        detailedDescription: "Going out of the tech zone Astranova promotes every talent ",
        date: "December, 2026",
        price: "NonTech Pass",
        venue: "Digital",
        teamSize: "1-4 Members",
        duration: "",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSfooQGCCEY4w4i5YrtCF9xCVbNGLeGJpvaimE33o6pFrJ2i0Q/viewform?usp=header",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/Screenshot%202026-12-20%20at%202.50.31%E2%80%AFPM.png",
        rules: [
          "Winner Based on likes",
          "Registrations close on January 3",
          "Participants can signup only once",
          "Voting will be Finalised on January 7"
        ],
        prizes: {
          first: "₹1,500",
          second: "500",
          third: "Vouchers",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Naveen Raj",
          phone: "+91 9500519389"
        },
        requirements: ["High Resolution Video"]
      },

      {name: "Anime Quiz",
        description: "Go Beyond. Plus Ultra!",
        detailedDescription:
          "The Anime Quiz Challenge is a thrilling online contest for anime lovers. Participants will test their knowledge of iconic shows, movies, characters, and storylines in a fast-paced and exciting quiz featuring both classics and modern hits.",
        date: "23-January, 2026",
        price: "NonTech Pass",
        venue: "CIT",
        teamSize: "Solo",
        duration: "1.5 hrs",
        registrationLink: "https://astranova2k26.com/passes",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/animequiz2k26.jpg",
        rules: [
          "Solo participation only",
          "Points awarded based on correctness and speed",
          "Use of external help or resources is prohibited",
          "Cheating leads to immediate disqualification",
          "Each question will have a fixed time limit"
        ],
        prizes: {
          first: "₹1000",
          second: "₹500",
          third: "Vouchers",
          others: ["Vouchers & Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Gokul SV",
          phone: "+91 7667224554"
        },
        requirements: [" To be a die hard anime fan"]
      },

      {name: "IPL Auction",
        description: "Bid Smart. Build Strong. Chase Glory.",
        detailedDescription:
          "Experience the thrill of an IPL-style auction as teams act as franchise owners. With a fixed purse, teams must strategically bid for players and build the strongest squad.",
        date: "23-January, 2026",
        price: "249",
        venue: "Campus",
        teamSize: "3–5 Members",
        duration: "2.5 hrs",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSdJWdkgrbpwb-xa-8wn5oj35pnvpdw28k4jBB7qkXufxe1DDQ/viewform?usp=dialog",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/IPL.avif",
        rules: [
          "Teams must have 3–5 members",
          "Each team must pick 7–8 players",
          "Ratings based on IPL performances",
          "Team with highest cumulative rating wins",
          "Auctioneer’s decision is final",
          "A quiz will divide teams into two panels"
        ],
        prizes: {
          first: "₹3000",
          second: "₹1000",
          third: "Vouchers",
          others: ["Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Yokesh",
          phone: "+91 9080867328"
        },
        requirements: ["Cricket knowledge and Math"]
      },

      {name: "Carrom",
        description: "Strike with Precision. Win with Strategy.",
        detailedDescription:
          "The Carrom tournament is a competitive indoor board game event where players showcase accuracy, strategy, and hand–eye coordination. The game tests concentration, patience, and tactical thinking under official rules.",
        date: "23-January, 2026",
        price: "99",
        venue: "CIT",
        teamSize: "Doubles",
        duration: "",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSeNkMLSK5gSKoyTCpW6F85NJ3X4pEfIg-oUN1GPWUJQ37_KLw/viewform?usp=dialog",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/Carrom-Board.jpg",
        rules: [
          "Matches will be conducted under official carrom rules",
          "Players must pocket carrom men and the queen correctly",
          "Fouls and penalties will be applied as per rules",
          "Unsportsmanlike behavior leads to disqualification",
          "Judges’ decisions are final"
        ],
        prizes: {
          first: "₹1000",
          second: "₹750",
          third: "Vouchers",
          others: ["Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Jeevanesan",
          phone: "+91 9342555966"
        },
        requirements: ["Basic knowledge of carrom rules"]
      },

      {name: "Squid Game",
          description: "Survive the Games. Claim Victory.",
          detailedDescription:
            "Inspired by the iconic Squid Game theme, this high-stakes event challenges participants with fast-paced games that test focus, speed, teamwork, and strategy.",
          date: "23-January, 2026",
          price: "NonTech Pass",
          venue: "Campus",
          teamSize: "Team Event",
          duration: "2 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/squid_game.png",
          rules: [
            "Participants must follow instructions for each game",
            "Failure to meet game requirements leads to elimination",
            "Game materials must be used as intended",
            "Cheating or tampering results in disqualification",
            "Maintain sportsmanship at all times",
            "Judges’ decisions are final"
          ],
          prizes: {
            first: "₹2000",
            second: "Vouchers",
            third: "Vouchers",
            others: ["Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Rahul Kanth",
            phone: "+91 6369883058"
          },
          requirements: ["Team coordination"]
        },

        {name: "Escape the room",
          description: "Solve Fast Or Stay Trapped",
          detailedDescription:
            "A locked room creates an exciting challenge where every detail matters. Search for hidden clues, solve clever puzzles, and connect hints spread across the room.",
          date: "23-January, 2026",
          price: "NonTech Pass",
          venue: "Campus",
          teamSize: "1-2 members",
          duration: "1.5 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/escape_the_room.PNG",
          rules: [
            "Participants must follow instructions for game",
            "Use only the clues and items provided inside the room.",
            "Mobile phones and external tools are not allowed.",
            "Cheating or tampering results in disqualification",
            "Follow the instructions of the game coordinator at all times.",
            "Prize will be based on completion of time."
          ],
          prizes: {
            first: "₹1000",
            second: "Vouchers",
            third: "Vouchers",
            others: ["Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Naveen",
            phone: "+91 9790289817"
          },
          requirements: ["Out of the Box Thinking"]
        },

    ],
    games: [
    
      
    ],
  },
  day2: {
    flagship: [
      { name: "The Grid Hackathon", 
        description: "National Level Hackathon",
        detailedDescription: "Astranova Hackathon is a pioneering initiative aimed at challenging students to ideate strategies and solutions to combat deceptive design practices in the e-commerce digital platforms.",
        date: "December 2026 - January 2026",
        price: "349",
        venue: "Exhibition Hall",
        teamSize: "2-4 Members",
        duration: "",
        registrationLink: "https://forms.gle/afQsMv2XHe1jTSQ88",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/HACKATHON.jpeg",
        rules: [
          "Original work only",
          "Abstract must be Submitted on date of Registration",
          "Presentation required",
          "Working prototype mandatory"
        ],
        prizes: {
          first: "₹15,000",
          second: "₹10,000",
          third: "₹5,000",
          others: ["Internship opportunities"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Pavishnu",
          phone: "+91 86106 46778"
        },
        requirements: ["Team of 2-4"]
      },
    ],
    technical: [

      {name: "Relay Coding",
          description: "One Team. Many Minds. One Finish Line.",
          detailedDescription:
            "Relay Coding is a four-round team-based competition combining coding challenges and fun non-technical tasks. Each round tests teamwork, speed, logic, and coordination, leading to an intense final showdown.",
          date: "24-January, 2026",
          price: "Tech Pass",
          venue: "CIT",
          teamSize: "3 Members",
          duration: "1.5 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/relay_coding.jpeg",
          rules: [
            "The event consists of 4 rounds",
            "Questions will be of Easy, Medium, and Hard levels",
            "Round 1 and Round 3 involve non-technical games",
            "Round 2 involves individual coding challenges",
            "Round 4 requires the team to solve a single problem by taking turns",
            "The team that solves the final challenge in the shortest time wins"
          ],
          prizes: {
            first: "₹1000",
            second: "₹500",
            third: "Vouchers",
            others: ["Vouchers & Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Praveen Kumar",
            phone: "+91 9345874188"
          },
          requirements: [
            "At least one team member must have a HackerRank account",
            "Challenges will be conducted on HackerRank",
            "Computers will be provided; personal laptops are recommended"
          ]
      },
      {name: "Code Hunt",
          description: "Decode the Mission. Execute the Win.",
          detailedDescription:
            "Code Hunt is a multi-level team-based coding challenge where participants restore critical spacecraft systems. Each level tests coding skills, logic, collaboration, and accuracy under increasing difficulty. Teams must clear all levels to secure a safe landing.",
          date: "24-January, 2026",
          price: "Tech Pass",
          venue: "CIT",
          teamSize: "2–3 Members",
          duration: "1.5 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/Codehunt.jpeg",
          rules: [
            "Each team must consist of 2 to 3 members",
            "Teams must successfully clear a level to advance to the next stage",
            "The difficulty of challenges increases at every level",
            "Use of external assistance or internet resources is strictly prohibited",
            "Any unethical practice will lead to disqualification"
          ],
          prizes: {
            first: "₹1000",
            second: "₹500",
            third: "Vouchers",
            others: ["Vouchers & Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Manikandan",
            phone: "+91 8778400884"
          },
          requirements: [
            "Basic knowledge of coding",
            "Participants must have active accounts on HackerRank, Google Forms, and Kahoot",
            "Coding will be conducted on HackerRank",
            "Computers will be provided; personal laptops are recommended as backup"
          ]
      },

      {name: "Code Golf",
          description: "Less Code. More Brains.",
          detailedDescription:
            "Code Golf is an adrenaline-fueled coding showdown where every character counts. Participants must solve problems with perfect output using the shortest possible code. Clever logic, optimization, and creativity determine the winner.",
          date: "24-January, 2026",
          price: "Tech Pass",
          venue: "CIT",
          teamSize: "Solo",
          duration: "1.5 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/golf.jpeg",
          rules: [
            "Solo participation only",
            "The contest consists of one round with three questions",
            "Time limits: Q1 – 10 min, Q2 – 20 min, Q3 – 30 min",
            "Participants must write the shortest optimized code",
            "Any programming language is allowed",
            "Use of pre-written code, libraries, plagiarism, or external help is prohibited",
            "Submitted code must produce correct output for all test cases"
          ],
          prizes: {
            first: "₹1000",
            second: "₹500",
            third: "Vouchers",
            others: ["Vouchers & Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Gokul",
            phone: "+91 9361482073"
          },
          requirements: [
            "Participants must have a HackerRank account",
            "Computers will be provided; personal laptops are recommended as backup"
          ]
      },
      {name: "TIK TIK TIK",
          description: "Every Second Counts. Every Move Matters.",
          detailedDescription:
            "TIK TIK TIK is a three-round competition that blends quizzes, debugging, and puzzle-solving. Teams are tested on logic, coding accuracy, speed, and deduction skills, with elimination rounds leading to a final winner.",
          date: "24-January, 2026",
          price: "Tech Pass",
          venue: "CIT",
          teamSize: "2–3 Members",
          duration: "2 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/tik.jpeg",
          rules: [
            "Round 1 is a Quizizz-based quiz on logic, tech, and general knowledge",
            "Round 2 involves debugging and completing partially written code",
            "Round 3 consists of puzzle-solving to identify a hidden word",
            "Judges’ decisions are final"
          ],
          prizes: {
            first: "₹6000",
            second: "₹2000",
            third: "Vouchers",
            others: ["Vouchers & Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Pranesh",
            phone: "+91 94422 60956"
          },
          requirements: [
            "At least one team member must have a HackerRank account",
            "Coding will be conducted on HackerRank",
            "Computers will be provided; personal laptops are recommended"
          ]
      },
      {name: "Seminar",
          description: "Dr. Somasundaram Balasubramaniam, Managing Director of DOMORETECH Consultancy Services Pvt. Ltd., will deliver an insightful seminar on Entrepreneurship Oppurtunities in Emerging Technologies",
          detailedDescription:"Dr. Somasundaram Balasubramaniam, Managing Director of DOMORETECH Consultancy Services Pvt. Ltd., will deliver an insightful seminar on Entrepreneurship Oppurtunities in Emerging Technologies, sharing industry-driven perspectives on innovation, digital transformation, and technology-led business leadership.",
          date: "24-January, 2026",
          price: "99",
          venue: "CIT",
          teamSize: "",
          duration: "1.5 hrs",
          registrationLink: "https://forms.gle/dXBTCG64Nh31zqXLA",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/SEMINAR.png",
          rules: [
          ],
          prizes: {
            others:["Certificates will be provided."]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Assun",
            phone: "+91  90803 69659"
          },
          requirements: [
            
          ]
      },

      {name: "Workshop",
          description: "Git & GitHub Essentials for efficient code management and collaboration, along with Figma for Developers",
          detailedDescription:"Karthikeyan Rajendran, Senior Executive IT at Lemnisk, will conduct an interactive workshop focusing on  Git & GitHub Essentials for efficient code management and collaboration, along with Figma for Developers to effectively connect design and development workflows. The session shares practical, industry-driven insights. ",
          date: "24-January, 2026",
          price: "99",
          venue: "CIT",
          teamSize: "",
          duration: "1.5 hrs",
          registrationLink: "https://forms.gle/ZKzPvHZs5WUQb8ty7",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/technical/WORKSHOP.png",
          rules: [
          ],
          prizes: {
            others:["Certificates will be provided."]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Assun",
            phone: "+91  90803 69659"
          },
          requirements: [
            
          ]
      },


    ],
    "non-technical": [
        {name: "Treasure Hunt",
          description: "Decode the Clues. Reach the Treasure.",
          detailedDescription:
            "A mysterious map guides participants through an adventurous campus journey filled with hidden clues, symbols, and checkpoints. Teams must decode hints and race against others to reach the final destination.",
          date: "24-January, 2026",
          price: "Golden Byte Pass",
          venue: "Campus",
          teamSize: "3 Members",
          duration: "2 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/treasure_hunt.JPG",
          rules: [
            "Each team must consist of 3 members",
            "All teams start with different clues but share the same destination",
            "The first two teams to reach the endpoint win",
            "Smartphones are allowed during the event"
          ],
          prizes: {
            first: "1 gram GOLD",
            second: "Vouchers",
            third: "Vouchers",
            others: ["Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Abhishek",
            phone: "+91 7448957009"
          },
          requirements: ["Smartphone", "Good observation skills"]
        },


        {name: "Movies Mania",
          description: "Lights. Camera. Guess!",
          detailedDescription:
            "Movies Mania is a celebration of cinema where teams connect visual clues to identify movies, actors, and concepts. From classics to blockbusters, it’s a cinematic quiz full of fun and excitement.",
          date: "24-January, 2026",
          price: "NonTech Pass",
          venue: "Campus",
          teamSize: "2–3 Members",
          duration: "1.5 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/Movies_mania.jpeg",
          rules: [
            "Teams must consist of 2–3 members",
            "Identify movies, actors, or concepts from pictures",
            "Team with the highest correct guesses wins",
            "Use of mobile phones or external help is prohibited",
            "Quizmaster’s decision is final"
          ],
          prizes: {
            first: "₹1000",
            second: "₹500",
            third: "Vouchers",
            others: ["Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Balakumaran",
            phone: "+91 8428924212"
          },
          requirements: ["Basic movie knowledge"]
        },

        {name: "True Detective",
        description: "Think Fast. Solve Smart. Escape in Time.",
        detailedDescription:
          "True Detective is an escape-room style event where participants put their logic, teamwork, and problem-solving skills to the test. Teams must solve puzzles and unravel clues to escape before time runs out.",
        date: "24-January, 2026",
        price: "NonTech Pass",
        venue: "Campus",
        teamSize: "Team Event",
        duration: "1.5 hrs",
        registrationLink: "https://astranova2k26.com/passes",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/detective-character.jpg",
        rules: [
          "Teams must work together to solve all puzzles",
          "All clues must be solved within the given time limit",
          "No external help is allowed",
          "Damaging props or clues leads to disqualification",
          "Organizers’ decisions are final"
        ],
        prizes: {
          first: "₹1000",
          second: "₹500",
          third: "Vouchers",
          others: ["Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Kavin",
          phone: "+91 6380126402"
        },
        requirements: ["Team coordination and logical thinking"]
      },

      {name: "Series Quiz",
          description: "You’re Either Right… or Out",
          detailedDescription:
            "The Series Quiz is a fun and engaging round featuring popular web series from Netflix and other platforms.",
          date: "24-January, 2026",
          price: "NonTech Pass",
          venue: "Campus",
          teamSize: "1-2 members",
          duration: "1.5 hrs",
          registrationLink: "https://astranova2k26.com/passes",
          imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/series_quiz.PNG",
          rules: [
            "Points awarded based on correctness and speed",
            "Use of external help or resources is prohibited",
            "Cheating leads to immediate disqualification",
            "Each question will have a fixed time limit",
          ],
          prizes: {
            first: "₹1000",
            second: "Vouchers",
            third: "Vouchers",
            others: ["Goodies"]
          },
          contact: {
            email: "astranova2k26.in@gmail.com",
            coordinator: "Dhanush",
            phone: "+91 7708692853"
          },
          requirements: ["If You Watched, You’ll Win"]
        },
    ],
    games: [
    { name: "BGMI", 
        description: "Battle Grounds Mobile India",
        detailedDescription: "INDIA KA BATTLEGROUNDS IS HERE",
        date: "January 21,22",
        price: "199",
        venue: "Online",
        teamSize: "2-4 Members",
        duration: "",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSeEeRj59blaNT77iJa6XWGa_3qUX34YFA_QxOHztisx965aNA/viewform?usp=publish-editor",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/website/bgmi.webp",
        rules: [
          "Cheats will result in ban"
        ],
        prizes: {
          first: "₹2000",
          second: "₹1000",
          third: "Vouchers",
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Gogul krishnan",
          phone: "+91 7397088306"
        },
        requirements: ["Team of 2-4"]
    },

      { name: "Free Fire", 
        description: "Battle Grounds Mobile India",
        detailedDescription: "INDIA KA BATTLEGROUNDS IS HERE",
        date: "January 19,20",
        price: "199",
        venue: "Online",
        teamSize: "2-4 Members",
        duration: "",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLScBTC8YendQ2L3omBgUOLMvkLKMI7selUJw4H40GliQ5ahM4Q/viewform?usp=publish-editor",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/website/Freefire.jpeg",
        rules: [
          "Cheats will result in ban"
        ],
        prizes: {
          first: "₹2000",
          second: "₹1000",
          third: "Vouchers",
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Kaviarasu",
          phone: "+91 7558141149"
        },
        requirements: ["Team of 2-4"]
      },
      {name: "Chess",
        description: "Think Ahead. Play Smart.",
        detailedDescription:
          "A competitive chess tournament conducted under official rules to test strategy, focus, and decision-making skills.",
        date: "20-January, 2026",
        price: "49",
        venue: "Digital",
        teamSize: "Solo",
        duration: "",
        registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSeDCcG-vbLV8a1zo4u6r0QzX2VDJ91ZolDfJo7Wb2yxFRhMUA/viewform?usp=dialog",
        imageUrl: "https://pub-b5827260d0074856b87ddecd2faaddaa.r2.dev/non-technical/chess.jpg",
        rules: [
          "Platform: Chess.com",
          "Game mode: Live match",
          "Time control: 10 minutes per player",
          "Swiss system format",
          "No external assistance allowed",
          "Violation of fair play rules leads to disqualification"
        ],
        prizes: {
          first: "₹1000",
          second: "₹500",
          third: "Vouchers",
          others: ["Goodies"]
        },
        contact: {
          email: "astranova2k26.in@gmail.com",
          coordinator: "Rahul Kanth",
          phone: "+91 6369883058"
        },
        requirements: ["Chess.com account"]
      },
    ],
  },
};